// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"b9981c10","302":"ec398b36","369":"d7d1d5f4","389":"0e2921c4"}[chunkId] + ".chunk.js";
};